import React from 'react';
import IconButton from '@mui/material/IconButton';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useFormContext } from '../../FormContext';
import { useAuthorization } from 'framework/authorization';
import { useFormShowContext } from '../FormShowContext';
import { useUiTheme } from 'framework/uiTheme';

type PermissionProp = {
  requiredPermission?: string | string[];
};

const hasPermission = (isGranted: (perm: string) => boolean, perms?: string | string[]) => {
  if (!perms) return false;
  if (Array.isArray(perms)) return perms.some(isGranted);
  return isGranted(perms);
};

export const EditFormShowButton: React.FC<PermissionProp> = ({ requiredPermission }) => {
  const { toggleEditMode } = useFormShowContext();
  const { isGranted } = useAuthorization();

  const canEdit = !requiredPermission || hasPermission(isGranted, requiredPermission);

  if (!canEdit) return null;

  return (
    <IconButton onClick={toggleEditMode} data-testid="edit-button">
      <AppRegistrationIcon color="primary" />
    </IconButton>
  );
};

type SaveFormShowButtonProps = {
  disabled?: boolean;
};

export const SaveFormShowButton = ({ disabled = false }: SaveFormShowButtonProps) => {
  const { submitForm = () => {}, isSubmitEnabled } = useFormContext();
  const { SmallLoader } = useUiTheme();
  return isSubmitEnabled ? (
    <IconButton onClick={submitForm} data-testid="save-button" disabled={disabled}>
      <CheckIcon color={disabled ? 'disabled' : 'success'} />
    </IconButton>
  ) : (
    <SmallLoader />
  );
};

export const CloseFormShowButton = () => {
  const { isSubmitEnabled } = useFormContext();
  const { toggleEditMode } = useFormShowContext();

  return (
    <IconButton onClick={toggleEditMode} disabled={!isSubmitEnabled}>
      <CloseIcon color="error" />
    </IconButton>
  );
};
